module.exports = __webpack_public_path__ + "img/qgjj-03.prt.d6dc876c.jpg";